import { IProgramType } from 'legacy/lut/features/partner360/configuration'
import { selectJBPSettingsCurrentFYear } from 'legacy/lut/features/partner360/jbpSettings'
import { getHasReadWriteAccess } from 'legacy/lut/selectors/app'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { selectEffectiveCockpitFYear } from '../selectors'

interface ICanSwitchOfferingInput {
  canEdit: boolean
  fYear: number
  currentFYear: number
  /** Nothing of the partner's is on: the switches are the only way in, for anyone. */
  isNothingOn: boolean
  offering: Pick<IProgramType, 'isDeprecated'>
}

/** The classic page's rule (`ProgramTypeButtonsControl`): its switches stand only in edit mode,
 *  which a user with write access gets for a live offering of the current year or a later one;
 *  with every offering off they stand for anyone. */
export const canSwitchCockpitOffering = ({
  canEdit,
  fYear,
  currentFYear,
  isNothingOn,
  offering,
}: ICanSwitchOfferingInput) =>
  isNothingOn || (canEdit && fYear >= currentFYear && !offering.isDeprecated)

/** Whether the user may switch a given offering of the partner on or off in the year on the board. */
export const useCanSwitchCockpitOffering = (offerings: IProgramType[]) => {
  const canEdit = useSelector(getHasReadWriteAccess)
  const fYear = useSelector(selectEffectiveCockpitFYear)
  const currentFYear = useSelector(selectJBPSettingsCurrentFYear)
  const isNothingOn = offerings.length > 0 && offerings.every(({ enabled }) => !enabled)

  return useCallback(
    (offering: Pick<IProgramType, 'isDeprecated'>) =>
      canSwitchCockpitOffering({ canEdit, fYear, currentFYear, isNothingOn, offering }),
    [canEdit, currentFYear, fYear, isNothingOn]
  )
}
